import React,
{
    // useState
    useRef
} from 'react'
import PropTypes from 'prop-types'
// Mol
import Modal, { ModalSize } from '../../Modal'
// import MServiceHomePartModal from '../../Modal/Part/MServiceHome'
import MSolicitarPartModal from '../../Modal/Part/MSolicitar'
import NumberFormat from 'react-number-format';

function PlayComPlanCardMol(props) {
    const {
        // title,
        fc_TEXTO_CAJA,
        fc_COLOR_CAJA,
        fc_NOMBRE,
        // fi_PLAN,
        // fi_ID_TELEFONIA,
        // fi_ID_TELEVISION,
        // fi_ID_INTERNET,
        // fi_CATEGORIA,
        // fc_TIPO_DISPONIBILIDAD,
        fc_DESCRIPCION,
        // fi_NUMERO_CARACTERISTICAS_MOSTRAR,
        // fc_TITULO_CARACTERISTICAS_AGRUPADAS,
        fi_PRECIO_PLAN,
        // fi_PRECIO_TELEFONIA_ENPS,
        // fi_PRECIO_TELEVISION_ESPN,
        // fi_PRECIO_INTERNET_ESPS,
        // fc_COLOR_PRECIO,
        // fc_ETIQUETA_PRECIO_TACHADO,
        // fc_PRECIO_TACHADO,
        // fc_NOTA_DEBAJO_PRECIO,
        // fc_TEXTO_DETALLE,
        // fc_URL_DETALLE,
        // fc_TARGET_DETALLE,
        // fi_BAN_DETALLE,
        fc_OPCION_CONTRATACION,
        fc_TEXTO_CONTRATAR,
        fc_URL_CONTRATAR,
        fc_TARGET_CONTRATAR,
        // fi_BAN_CONTRATAR,
        // fi_ORDEN,
        // fi_ACTIVO,
        // fi_ID_DASHBOARD,
        // fi_BAN_ENPN,
        // fi_BAN_ENPS,
        // fi_BAN_ESPN,
        // fi_BAN_ESPS,
        // fc_ETIQUETA_PROMOCION_ATP,
        // fi_PRECIO_AHORRO,
        fc_ETIQUETA_PERIODO,
        // Caracteristicas,
        // Acordeon,
        lstPlanContratacionxPlan,
    } = props
    // const modalServiceRef = useRef()
    const modalRequestRef = useRef()
    // const openModalService = () => modalServiceRef.current.open()
    const openModalRequest = () => modalRequestRef.current.open()
    const onClickRequest = () => {
        console.log('Contratar')
        openModalRequest()
    }
    console.log("PlayComPlanCardMol props:", props)
    let titlestyle = fc_COLOR_CAJA ? fc_COLOR_CAJA : 'amarillo';
    return (
        <>
            <div className={'cardPlan ' + titlestyle.toLowerCase()}>

                <div className="cardPlanTitleComp">
                    <h3 className="cPlanTitleLabel">
                        <strong>
                            <span>
                                {fc_TEXTO_CAJA}
                            </span>

                        </strong>
                        <span>
                            {fc_NOMBRE}
                        </span>

                    </h3>
                    {
                        fc_DESCRIPCION ?
                            <p>
                                {fc_DESCRIPCION}
                            </p>
                            : null
                    }
                </div>

                <div className="cardPlanPriceComp">

                    <div className="cPlanPriceBlock">
                        <div className="cPlanPriceTemp">
                            {
                                fc_ETIQUETA_PERIODO ?
                                    <p className='introText'>
                                        {fc_ETIQUETA_PERIODO}
                                    </p>
                                    : null
                            }
                        </div>
                        <div className="cPlanCurrentPrice">
                            {
                                fi_PRECIO_PLAN ?
                                    <p>
                                        <span className="symbol"> $</span>
                                        <span className="cPrice">{<NumberFormat thousandSeparator={"."} decimalSeparator={","} displayType={'text'} value={fi_PRECIO_PLAN} />}</span>
                                        {/* <span className="sup"> .00</span> */}
                                    </p>
                                    : null
                            }
                        </div>
                        {/* <div className="cPlanPrevPrice">
						<p>Antes: $ 12.999</p> 
                    </div> */}
                    </div>
                    {/* <p className="leyend">
                    *Oferta exclusiva Portabilidad
                </p>  */}
                </div>
                <div className="cardPlanActionsComp">
                    {
                        fc_TEXTO_CONTRATAR ?
                            fc_OPCION_CONTRATACION !== "LBX" ?
                                <a className="btn btnBlancoRojo" href={fc_URL_CONTRATAR} target={fc_TARGET_CONTRATAR ? fc_TARGET_CONTRATAR : '_self'}>
                                    {fc_TEXTO_CONTRATAR}
                                </a>
                                :
                                <a className="btn btnBlancoRojo" href="#!" onClick={() => onClickRequest()} target={fc_TARGET_CONTRATAR ? fc_TARGET_CONTRATAR : '_self'}>
                                    {fc_TEXTO_CONTRATAR}
                                </a>
                            : null
                    }
                </div>

            </div>
            <Modal
                ref={modalRequestRef}
                size={ModalSize.SMALL}
            >
                <MSolicitarPartModal
                    title={fc_TEXTO_CAJA}
                    name={fc_NOMBRE}
                    fc_DESCRIPCION={fc_DESCRIPCION}
                    fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                    fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                    lstPlanContratacionxPlan={lstPlanContratacionxPlan}
                />
            </Modal>
        </>
    )
}

PlayComPlanCardMol.defaultProps = {
    title: '3 Play',
    price: '99999',
}
PlayComPlanCardMol.propTypes = {
    title: PropTypes.string,
    price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
}

export default PlayComPlanCardMol
